import { render } from "./ListCarsUsados.vue?vue&type=template&id=6847d627"
import script from "./ListCarsUsados.vue?vue&type=script&lang=js"
export * from "./ListCarsUsados.vue?vue&type=script&lang=js"

import "./ListCarsUsados.vue?vue&type=style&index=0&id=6847d627&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__